import styled from "styled-components";

export const FullHeight = styled.div`
  height: 100%;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
`;
